
const APP_LIST_LIST = 'APP_LIST_LIST';
const APP_LIST_PAGE = 'APP_LIST_PAGE';
const APP_LIST_CONDITION = 'APP_LIST_CONDITION';
const APP_LIST_ADD_CONDITION = 'APP_LIST_ADD_CONDITION';

const AppListModel = function () {
  const name = 'AppList';
  return {
    name,
    state: {
      list: [],
      condition: {
        name: '',
      },
      addCondition:{
        id:'',
        miniAppid:'',
        miniSecret:'',
        forinsid:'',
        name:'',
        appname:'',
        appKey:'',
        appType:'',
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getAddCondition: () => currentState.addCondition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: APP_LIST_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: APP_LIST_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: APP_LIST_CONDITION,
          key,
          value
        });
      },
      changeAddCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: APP_LIST_ADD_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = AppListModel.state.list, action) => {
        if (action.type === APP_LIST_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = AppListModel.state.page, action) => {
        if (action.type === APP_LIST_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = AppListModel.state.condition, action) => {
        if (action.type === APP_LIST_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      addCondition: (state = AppListModel.state.addCondition, action) => {
        if (action.type === APP_LIST_ADD_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      }
    }
  };
}();

export default AppListModel;


// WEBPACK FOOTER //
// ./src/models/AppListModel.js